var _defs, _line, _g, _line2, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewCeilingToFloor3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "213px",
    height: "244px",
    viewBox: "0 0 569 650",
    enableBackground: "new 0 0 569 650",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t\t\t@font-face {\r\n\t\t\tfont-family: \"proximanova-nova\";\r\n\r\n\t\t\tsrc: url('https://doopsalta2.com/Fonts/proxima-nova-three.woff2') format('woff2'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.woff') format('woff'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.otf') format('opentype');\r\n\t\t\tfont-style: normal;\r\n\t\t\t}\r\n\t\t"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 0,
    y1: 645.2,
    x2: 460,
    y2: 645.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M132.2,18.7l6.5-16h2.5l6.4,16h-2.3l-1.4-3.6h-8l-1.4,3.6H132.2z M136.5,13.4h6.8l-3.4-8.6L136.5,13.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M224.3,18.7v-16h7.1c1.4,0,2.5,0.4,3.3,1.1c0.8,0.8,1.2,1.7,1.2,3c0,1-0.3,1.8-0.8,2.4s-1.2,1.1-2,1.2 c0.8,0.1,1.6,0.6,2.2,1.4c0.6,0.8,0.9,1.6,0.9,2.6c0,1.3-0.4,2.4-1.2,3.1c-0.8,0.8-2,1.2-3.4,1.2H224.3z M226.3,9.6h4.8 c0.9,0,1.6-0.2,2-0.7s0.7-1.1,0.7-1.8s-0.2-1.4-0.7-1.9s-1.2-0.7-2-0.7h-4.8V9.6z M226.3,16.9h4.9c0.9,0,1.6-0.2,2.2-0.7 c0.5-0.5,0.8-1.2,0.8-2s-0.3-1.4-0.8-2s-1.2-0.8-2.2-0.8h-4.9V16.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M315,14.1c-0.4-1-0.6-2.2-0.6-3.4s0.2-2.3,0.6-3.4s1-1.9,1.7-2.6s1.6-1.3,2.6-1.7s2.1-0.6,3.2-0.6 c2.6,0,4.6,1.1,6.1,3.2L327,6.5c-0.5-0.7-1.1-1.3-1.9-1.7s-1.6-0.6-2.5-0.6c-1.8,0-3.2,0.6-4.4,1.8s-1.8,2.8-1.8,4.7 c0,1.2,0.3,2.4,0.8,3.4s1.3,1.8,2.2,2.3c0.9,0.6,2,0.8,3.1,0.8c0.9,0,1.7-0.2,2.5-0.6s1.4-1,1.9-1.7l1.7,0.9 c-1.6,2.1-3.6,3.2-6.1,3.2c-1.1,0-2.2-0.2-3.2-0.6s-1.9-1-2.6-1.7C316,16,315.4,15.1,315,14.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.9,
    y: 176.7,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 199.8,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 320.7,
    y1: 82.6,
    x2: 320.7,
    y2: 632.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "311.7,85.2 320.7,69.7 329.7,85.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "311.7,629.6 320.7,645.2 329.7,629.6  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 229.5,
    y1: 82.6,
    x2: 229.5,
    y2: 632.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "220.5,85.2 229.5,69.7 238.4,85.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "220.5,629.6 229.5,645.2 238.4,629.6  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 139.3,
    y1: 82.6,
    x2: 139.3,
    y2: 632.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "130.3,85.2 139.3,69.7 148.3,85.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "130.3,629.6 139.3,645.2 148.3,629.6  "
  }))))))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 0,
    y1: 69.7,
    x2: 460,
    y2: 69.7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M471,65c-0.4-1-0.6-2.1-0.6-3.2c0-1.2,0.2-2.2,0.6-3.2c0.4-1,1-1.8,1.7-2.5c0.7-0.7,1.5-1.2,2.5-1.6 c1-0.4,2-0.6,3.1-0.6c2.5,0,4.4,1,5.8,3l-1.6,0.9c-0.4-0.7-1.1-1.2-1.8-1.6c-0.8-0.4-1.6-0.6-2.4-0.6c-1.7,0-3.1,0.6-4.2,1.7 s-1.7,2.7-1.7,4.5c0,1.2,0.3,2.3,0.8,3.2s1.2,1.7,2.1,2.2c0.9,0.5,1.9,0.8,3,0.8c0.9,0,1.7-0.2,2.4-0.6s1.4-1,1.8-1.6l1.6,0.9 c-1.5,2-3.4,3.1-5.8,3.1c-1.1,0-2.1-0.2-3.1-0.6c-1-0.4-1.8-0.9-2.5-1.6C471.9,66.8,471.4,66,471,65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M488.8,69.4V54.1h10.1v1.7h-8.1v4.9h8v1.7h-8v5.3h8.1v1.7H488.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M504.2,69.4V54.1h1.9v15.3H504.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M511.8,69.4V54.1h1.9v13.6h7.1v1.7H511.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M525.6,69.4V54.1h1.9v15.3H525.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M533.4,69.4V54.1h2l8.8,12v-12h1.9v15.3h-1.8l-8.9-12.2v12.2H533.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M552,65c-0.4-1-0.6-2.1-0.6-3.3s0.2-2.3,0.6-3.3s1-1.8,1.7-2.5c0.7-0.7,1.5-1.2,2.5-1.6 c1-0.4,2-0.6,3.1-0.6c2.4,0,4.4,1,6,2.9l-1.5,1c-0.5-0.6-1.1-1.2-1.9-1.5c-0.8-0.4-1.6-0.6-2.5-0.6c-1.7,0-3.1,0.6-4.2,1.7 s-1.7,2.7-1.7,4.5c0,1.2,0.3,2.3,0.8,3.2c0.5,1,1.2,1.7,2.1,2.2c0.9,0.5,1.9,0.8,3,0.8c0.8,0,1.6-0.2,2.4-0.5 c0.7-0.3,1.3-0.7,1.8-1.2v-3.1h-5.3v-1.7h7.2V67c-0.7,0.8-1.6,1.5-2.7,1.9s-2.2,0.7-3.4,0.7c-1.1,0-2.1-0.2-3.1-0.6 c-1-0.4-1.8-0.9-2.5-1.6C553,66.8,552.4,66,552,65z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M470.4,644.9v-15.3h10.1v1.7h-8.1v4.9h8v1.7h-8v7H470.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M485.1,644.9v-15.3h1.9v13.6h7.1v1.7H485.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M499.3,641.3c-0.6-1.2-0.9-2.6-0.9-4.1s0.3-2.8,0.9-4.1c0.6-1.2,1.5-2.2,2.7-2.8s2.5-1,4-1 c1.5,0,2.8,0.3,4,1c1.2,0.7,2.1,1.6,2.7,2.8c0.6,1.2,1,2.6,1,4.1s-0.3,2.8-1,4.1c-0.6,1.2-1.5,2.2-2.7,2.8c-1.2,0.7-2.5,1-4,1 c-1.5,0-2.8-0.3-4-1S499.9,642.5,499.3,641.3z M500.3,637.3c0,1.2,0.2,2.2,0.7,3.2c0.5,0.9,1.1,1.7,2,2.2c0.9,0.5,1.9,0.8,3,0.8 s2.1-0.3,3-0.8c0.9-0.5,1.5-1.3,2-2.2s0.7-2,0.7-3.2c0-1.8-0.5-3.3-1.6-4.5c-1-1.2-2.4-1.8-4.1-1.8c-1.7,0-3.1,0.6-4.1,1.8 C500.8,633.9,500.3,635.4,500.3,637.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M519.2,641.3c-0.6-1.2-0.9-2.6-0.9-4.1s0.3-2.8,0.9-4.1c0.6-1.2,1.5-2.2,2.7-2.8s2.5-1,4-1 c1.5,0,2.8,0.3,4,1c1.2,0.7,2.1,1.6,2.7,2.8c0.6,1.2,1,2.6,1,4.1s-0.3,2.8-1,4.1c-0.6,1.2-1.5,2.2-2.7,2.8c-1.2,0.7-2.5,1-4,1 c-1.5,0-2.8-0.3-4-1S519.8,642.5,519.2,641.3z M520.2,637.3c0,1.2,0.2,2.2,0.7,3.2c0.5,0.9,1.1,1.7,2,2.2c0.9,0.5,1.9,0.8,3,0.8 s2.1-0.3,3-0.8c0.9-0.5,1.5-1.3,2-2.2s0.7-2,0.7-3.2c0-1.8-0.5-3.3-1.6-4.5c-1-1.2-2.4-1.8-4.1-1.8c-1.7,0-3.1,0.6-4.1,1.8 C520.7,633.9,520.2,635.4,520.2,637.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M538.7,644.9v-15.3h6.2c1.4,0,2.6,0.4,3.5,1.3c0.9,0.8,1.3,2,1.3,3.4c0,0.7-0.1,1.3-0.3,1.8 c-0.2,0.6-0.5,1-0.9,1.4c-0.4,0.4-0.8,0.7-1.3,0.9s-1,0.3-1.5,0.4l4.1,6.2h-2.3l-3.9-6.1h-3.1v6.1H538.7z M540.6,637.1h4 c0.9,0,1.6-0.3,2.2-0.8c0.6-0.5,0.9-1.3,0.9-2.1s-0.3-1.6-0.9-2.1c-0.6-0.5-1.3-0.8-2.2-0.8h-4V637.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCeilingToFloor3);
export default __webpack_public_path__ + "static/media/new_ceiling_to_floor_3.d112d78425b6a481e7a507a20670bc20.svg";
export { ForwardRef as ReactComponent };